import { useState, useCallback } from 'react';
import type { PersistResult } from './qualityPersistence.js';

export function useInlineError(): [
  error: string | null,
  showError: (msg: string) => void,
  clearError: () => void,
] {
  const [error, setError] = useState<string | null>(null);
  const showError = useCallback((msg: string) => setError(msg), []);
  const clearError = useCallback(() => setError(null), []);
  return [error, showError, clearError];
}

/** Formats a failed PersistResult into a user-visible message. */
export function persistErrorMessage(
  r: Extract<PersistResult, { ok: false }>,
  action: string,
): string {
  if (r.reason === 'quota') {
    return `Storage full — couldn't ${action}. Clear browser data or sign in to sync.`;
  }
  return `Couldn't ${action} (${r.message ?? 'unknown'}).`;
}
